import { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router'
import { CustomDropdown } from '../../../../ui/dropdown/CustomDropdown';
import { CustomDropdownButton } from '../../../../ui/dropdown/CustomDropdownButton';
import { CustomDropdownMenu } from '../../../../ui/dropdown/CustomDropdownMenu';
import { CustomDropdownMenuList } from '../../../../ui/dropdown/CustomDropdownMenuList';

const Tabing = ({
    bottomTabs = [],
    style,
    className,
    activeKey,
    onChange = () => { },
    defaultActive,
    isExtraComponent = false,
    ExtraComponent = () => { },
    moreOpt = false,
    moreCount = 8
}) => {
    const navigate = useNavigate()
    const location = useLocation()
    const containerRef = useRef(null)
    const tabRefs = useRef([])

    const MIN_TABS = 2
    const MORE_BUTTON_WIDTH = 90

    const [tabs, setTabs] = useState(bottomTabs)
    const [dynamicMoreCount, setDynamicMoreCount] = useState(moreCount)
    const [activeTab, setActiveTab] = useState("/")

    // Update tabs if bottomTabs change
    useEffect(() => setTabs(bottomTabs), [bottomTabs])

    // Set active tab based on route or defaultActive
    useEffect(() => {
        const current = tabs.find(tab =>
            tab.url && location.pathname.startsWith(tab.url)
        )
        if (current && !defaultActive) setActiveTab(current.activeKey)
        else setActiveTab(defaultActive || tabs[0]?.activeKey || "")
    }, [location.pathname, tabs, defaultActive])

    // Move active tab into visible area if in dropdown
    const bringTabToFront = (targetTab, maxVisibleCount = dynamicMoreCount) => {
        const index = tabs.findIndex(t => t.activeKey === targetTab.activeKey)
        if (index === -1 || index < maxVisibleCount) return

        const updated = [...tabs]
        updated.splice(index, 1)
        setTabs([
            ...updated.slice(0, maxVisibleCount - 1),
            targetTab,
            ...updated.slice(maxVisibleCount - 1)
        ])
    }

    useEffect(() => {
        const current = tabs.find(tab =>
            tab.url && location.pathname.startsWith(tab.url)
        )
        if (!current) return
        setActiveTab(current.activeKey)
        if (moreOpt) bringTabToFront(current)
    }, [location.pathname, tabs])

    // Calculate visible tabs based on container width and ensure active tab is visible
    useEffect(() => {
        if (!moreOpt || !containerRef.current || !tabRefs.current) return

        const calculateVisibleTabs = () => {
            tabRefs.current = tabRefs.current.slice(0, tabs.length)
            const containerWidth = containerRef?.current?.offsetWidth
            const availableWidth = containerWidth - MORE_BUTTON_WIDTH

            let usedWidth = 0
            let count = 0

            for (let i = 0; i < tabs.length; i++) {
                const tab = tabRefs.current[i];
                if (!tab) continue;
                const tabWidth = tab?.offsetWidth;
                if (usedWidth + tabWidth > availableWidth) break;
                usedWidth += tabWidth;
                count++;
            }

            let newDynamicCount = Math.max(count, MIN_TABS)

            // Ensure active tab is always visible
            const activeIndex = tabs.findIndex(tab => tab.activeKey === activeTab)
            if (activeIndex >= newDynamicCount) {
                // Move active tab to last visible slot
                const updatedTabs = [...tabs]
                const activeTabObj = updatedTabs.splice(activeIndex, 1)[0]
                updatedTabs.splice(newDynamicCount - 1, 0, activeTabObj)
                setTabs(updatedTabs)
                newDynamicCount = Math.max(newDynamicCount, activeIndex + 1)
            }

            if (newDynamicCount !== dynamicMoreCount) {
                setDynamicMoreCount(newDynamicCount)
            }
        }

        const ro = new ResizeObserver(calculateVisibleTabs)
        ro.observe(containerRef.current)
        calculateVisibleTabs()

        return () => ro.disconnect()
    }, [tabs, moreOpt, activeTab])

    // const visibleTabs = moreOpt ? tabs.slice(0, dynamicMoreCount) : tabs
    // const extraTabs = moreOpt ? tabs.slice(dynamicMoreCount) : []

    const handleExtraTabClick = (eachTab) => {
        bringTabToFront(eachTab)
        setActiveTab(eachTab.activeKey)
        onChange(eachTab.activeKey)
        if (eachTab.url) navigate(eachTab.url)
    }

    // Compute visible and extra tabs dynamically every render
    const computeTabs = () => {
        let visible = bottomTabs.slice(0, dynamicMoreCount)
        let extra = bottomTabs.slice(dynamicMoreCount)

        // If active tab is hidden, move it as last visible
        const activeHidden = extra.find(tab => tab.activeKey === activeTab)
        if (activeHidden) {
            extra = extra.filter(tab => tab.activeKey !== activeTab)
            visible = [...visible, activeHidden]
        }

        return { visibleTabs: visible, extraTabs: extra }
    }

    const { visibleTabs, extraTabs } = moreOpt ? computeTabs() : { visibleTabs: bottomTabs, extraTabs: [] }

    return (
        <div className="flex w-[calc(100%-450px)]" ref={containerRef}>
            <div className={`${style.headerBottom_tabs} ${className?.headerBottom_tabs} ${moreOpt ? "!flex-nowrap" : ""}`}>
                {tabs.map((eachTab, i) => {
                    const isVisible = !moreOpt || i < dynamicMoreCount
                    const TabComponent = eachTab.hasOwnProperty("url") ? Link : "div"
                    return (
                        <TabComponent
                            key={eachTab.activeKey}
                            ref={el => (tabRefs.current[i] = el)}
                            to={!eachTab?.url ? "" : eachTab.url}
                            className={`
                                ${style.headerBottom_tabs__items}
                                ${className?.headerBottom_tabs__items}
                                ${activeTab === eachTab.activeKey ? `${style.active} ${className?.active}` : ""}
                                ${!isVisible ? "opacity-0 absolute pointer-events-none" : ""}
                            `}
                            onClick={(e) => {
                                if(TabComponent !== 'div') {
                                    if (!eachTab?.url) {
                                        e.preventDefault(); // 👈 prevent navigation
                                        return;
                                    }
                                }
                                setActiveTab(eachTab.activeKey)
                                onChange(eachTab.activeKey)
                                if (eachTab.url) navigate(eachTab.url)
                            }}
                        >
                            <span>{eachTab?.name === "Loyality Fund Companys Contribution" ? "Loyality Fund" : eachTab?.name}</span>
                        </TabComponent>
                    )
                })}

                {/* MORE DROPDOWN */}
                {moreOpt && extraTabs.length > 0 && (
                    <CustomDropdown position="bottom-center" className="myDropdown">
                        <CustomDropdownButton arrow={false} className={'!bg-transparent !border-none !p-0'}>
                            <div className={`${style.headerBottom_tabs__items}`}>
                                <span>More</span>
                            </div>
                        </CustomDropdownButton>

                        <CustomDropdownMenu className="w-[230px] flex flex-col gap-2">
                            {extraTabs.map((eachTab, i) => {
                                const TabComponent = eachTab.hasOwnProperty("url") ? Link : "div"
                                return (
                                    <CustomDropdownMenuList
                                        key={i}
                                        onClick={(e) => {
                                            if (TabComponent !== "div") {
                                                if (!eachTab?.url) {
                                                    e.preventDefault(); 
                                                    return;
                                                } else {
                                                    handleExtraTabClick(eachTab)
                                                }
                                            } else {
                                                handleExtraTabClick(eachTab)
                                            }
                                        }}
                                    >
                                        <div className="d-flex whitespace-normal text-nowrap align-items-center gap-1">
                                            {eachTab?.name === "Loyality Fund Companys Contribution" ? "Loyality Fund" : eachTab?.name}
                                        </div>
                                    </CustomDropdownMenuList>
                                )
                            })}
                        </CustomDropdownMenu>
                    </CustomDropdown>
                )}

                {isExtraComponent &&
                    <ExtraComponent className={`${style.headerBottom_tabs__items} ${className?.headerBottom_tabs__items}`} />
                }
            </div>
        </div>
    )
}

export default Tabing
